(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name FOrderService
     *@description
     *Servicio de autores
     */

    angular
        .module('appback')
        .factory('FOrderService', FOrderService);

    FOrderService.$inject = ["$http"];

    function FOrderService($http) {

        var order = {
            Getorder: Getorder,
            Getallorders: Getallorders,
            Getphases: Getphases,
            GetHistories: GetHistories,
            Getlines: Getlines,
            Getline: Getline,
            GetActiveOrder: GetActiveOrder,
            Getuser: Getuser,
        };

        function Getorder(id) {
            return $http.get('/backend/fabrication_order/getorder', {
                params: {
                    id: id
                },
                headers: {}
            }).then(function (response) {
                return response.data.data;
            }, function (error) {
                return error;
            });
        }

        function GetActiveOrder(id) {
            // return $http.get('/rest/getactiveorder', {
            //     params: {
            //         id: id
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        function Getallorders() {
            // return $http.get('/rest/getallorders', {
            //     params: {
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        function Getphases() {
            // return $http.get('/rest/getphases', {
            //     params: {
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        function GetHistories(id) {
            // return $http.get('/rest/gethistories', {
            //     params: {
            //         id: id
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        function Getlines() {
            // return $http.get('/rest/getlines', {
            //     params: {
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        function Getline(id) {
            // return $http.get('/rest/getline', {
            //     params: {
            //         id: id
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        function Getuser() {
            // return $http.get('/rest/getuser', {
            //     params: {
            //     },
            //     headers: {}
            // }).then(function (response) {
            //     return response.data;
            // }, function (error) {
            //     return error;
            // });
        }

        return order;
    }
})();

